"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPlacementSizes = void 0;
var getPlacementDetails_1 = require("./getPlacementDetails");
var getResponsivePlacementSizes_1 = require("./getResponsivePlacementSizes");
/**
 * return all the sets of sizes that a placement supports
 */
function getPlacementSizes(placement) {
    var placementDetails = (0, getPlacementDetails_1.getPlacementDetails)(placement);
    if (!placementDetails ||
        (!placementDetails.sizes && !placementDetails.responsiveSizes)) {
        return undefined;
    }
    else if (placementDetails.responsiveSizes) {
        return (0, getResponsivePlacementSizes_1.getResponsivePlacementSizes)(placementDetails.responsiveSizes, window.innerWidth);
    }
    return Object.values(placementDetails.sizes);
}
exports.getPlacementSizes = getPlacementSizes;
